module.exports = __webpack_public_path__ + "img/PK.2aa9be51.svg";